"use client";
import React from "react";
import { FooterLogo } from "./FooterLogo";
import { FooterMenuColumn } from "./FooterMenuColumn";
import { FooterSubscribe } from "./FooterSubscribe";
import { FooterSocialIcons } from "./FooterSocialIcons";

const Footer = () => {
  const aboutItems = [
    "Companies",
    "Pricing",
    "Terms",
    "Advice",
    "Privacy Policy",
  ];

  const resourceItems = ["Help Docs", "Guide", "Updates", "Contact Us"];

  return (
    <footer className="px-32 pt-16 pb-10 bg-gray-800 max-md:px-5 max-md:py-10 max-sm:px-4 max-sm:py-8">
      <div className="flex justify-between my-0 max-w-[1192px] max-md:flex-col max-md:gap-10">
        <section className="w-[376px] max-md:w-full">
          <FooterLogo />
          <p className="text-base leading-6 text-zinc-200">
            Great platform for the job seeker that passionate about startups.
            Find your dream job easier.
          </p>
        </section>

        <div className="flex gap-24 max-md:gap-10 max-md:mx-0 max-md:my-10 max-sm:flex-col max-sm:gap-8">
          <FooterMenuColumn title="About" items={aboutItems} />
          <FooterMenuColumn title="Resources" items={resourceItems} />
        </div>

        <FooterSubscribe />
      </div>

      <hr className="mx-0 my-10 h-px bg-white bg-opacity-10" />

      <div className="flex justify-between items-center mx-auto my-0 max-w-[1192px] max-sm:flex-col max-sm:gap-5 max-sm:text-center">
        <p className="text-base font-medium text-white text-opacity-50">
          2025 @ AneefDev. All rights reserved.
        </p>
        <FooterSocialIcons />
      </div>
    </footer>
  );
};

export default Footer;
